<div class="oip" [class.oip--open]="open" [class.oip--disabled]="disabled" dir="rtl">

  <!-- Field (looks like an input; holds the chosen items as chips) -->
  <div
    #trigger
    class="oip__trigger input-2026"
    role="combobox"
    [attr.tabindex]="disabled ? -1 : 0"
    aria-haspopup="listbox"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="uid + '-panel'"
    [attr.aria-labelledby]="labelledBy"
    [attr.aria-disabled]="disabled || null"
    (click)="toggle()"
    (keydown)="onTriggerKeydown($event)"
  >
    <span *ngIf="selected.length === 0" class="oip__placeholder">{{ placeholder }}</span>

    <span *ngFor="let value of selected" class="oip__chip">
      <span>{{ labelOf(value) }}</span>
      <button
        type="button"
        class="oip__chip-x"
        tabindex="-1"
        [disabled]="disabled"
        [attr.aria-label]="'הסר ' + labelOf(value)"
        (click)="remove(value, $event)"
      >
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </span>

    <span class="oip__caret material-symbols-outlined" aria-hidden="true">
      {{ open ? 'expand_less' : 'expand_more' }}
    </span>
  </div>

  <!-- Dropdown panel: search + every option in columns -->
  <div *ngIf="open" #panel [id]="uid + '-panel'" class="oip__panel">

    <div class="oip__search">
      <span class="material-symbols-outlined oip__search-icon" aria-hidden="true">search</span>
      <input
        #search
        type="text"
        class="oip__search-input"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        placeholder="הקלד לחיפוש מהיר… (חיצים לניווט, Enter לבחירה)"
        role="combobox"
        aria-autocomplete="list"
        aria-expanded="true"
        [attr.aria-controls]="uid + '-list'"
        [attr.aria-activedescendant]="highlightedId"
        [value]="query"
        (input)="onQuery($any($event.target).value)"
        (keydown)="onSearchKeydown($event)"
      />
      <button
        *ngIf="query"
        type="button"
        class="oip__search-clear"
        aria-label="נקה חיפוש"
        (click)="onQuery(''); search.focus()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </div>

    <div
      [id]="uid + '-list'"
      class="oip__columns"
      role="listbox"
      aria-multiselectable="true"
      [attr.aria-labelledby]="labelledBy"
      [style.grid-template-columns]="'repeat(' + (columns.length || 1) + ', minmax(0, 1fr))'"
    >
      <div *ngFor="let col of columns" class="oip__col">
        <section *ngFor="let group of col" class="oip__group" role="group" [attr.aria-label]="group.label">
          <h4 class="oip__group-title">{{ group.label }}</h4>
          <button
            *ngFor="let opt of group.options"
            type="button"
            role="option"
            tabindex="-1"
            [id]="opt.id"
            class="oip__option"
            [class.is-selected]="isSelected(opt.value)"
            [class.is-highlighted]="opt.id === highlightedId"
            [attr.aria-selected]="isSelected(opt.value)"
            (click)="clickOption(opt.value, opt.id)"
            (mouseenter)="highlightById(opt.id)"
          >
            <span class="material-symbols-outlined oip__check" aria-hidden="true">
              {{ isSelected(opt.value) ? 'check_box' : 'check_box_outline_blank' }}
            </span>
            <span class="oip__option-label">{{ opt.label }}</span>
          </button>
        </section>
      </div>

      <p *ngIf="noResults" class="oip__empty">לא נמצא פריט שמתאים ל־"{{ query }}"</p>
    </div>

    <div class="oip__footer">
      <span class="oip__count" aria-live="polite">
        {{ selected.length === 0 ? 'לא נבחר כלום' : 'נבחרו ' + selected.length }}
      </span>
      <div class="oip__footer-actions">
        <button type="button" class="btn-2026--ghost oip__btn" (click)="clearAll()" [disabled]="!selected.length">
          נקה הכל
        </button>
        <button type="button" class="btn-2026--primary oip__btn" (click)="close()">
          <span class="material-symbols-outlined" aria-hidden="true">done</span>
          סיום
        </button>
      </div>
    </div>
  </div>
</div>
